import { collection, deleteDoc, doc, getFirestore, onSnapshot, setDoc, serverTimestamp } from './instrumentedFirestore';
import { getFirebaseApp } from './app';
import { COLLECTIONS } from '@constants/firestorePaths';

function db() {
    return getFirestore(getFirebaseApp());
}

function monthEntriesCollection({ tenantId, scope, monthKey }) {
    if (typeof COLLECTIONS.ATTENDANCE !== 'string' || !COLLECTIONS.ATTENDANCE) {
        throw new Error('Attendance collection is not configured');
    }
    if (!tenantId) throw new Error('Missing tenantId');
    if (!scope) throw new Error('Missing scope');
    if (!monthKey) throw new Error('Missing monthKey');
    if (!/^\d{4}-\d{2}$/.test(monthKey)) throw new Error(`Invalid monthKey: ${monthKey}`);
    if (scope !== 'teachers' && scope !== 'staff' && scope !== 'students') throw new Error(`Invalid scope: ${scope}`);
    return collection(db(), COLLECTIONS.ATTENDANCE, tenantId, scope, monthKey, 'entries');
}

export function subscribeAttendanceMonthEntries({ tenantId, scope, monthKey, onNext, onError }) {
    try {
        const col = monthEntriesCollection({ tenantId, scope, monthKey });
        return onSnapshot(
            col,
            (snap) => {
                const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
                onNext?.(rows);
            },
            (err) => onError?.(err)
        );
    } catch (e) {
        onError?.(e);
        return () => {};
    }
}

export async function upsertAttendanceEntry({ tenantId, scope, monthKey, dateKey, personId, status, checkInTime, reason }) {
    if (typeof COLLECTIONS.ATTENDANCE !== 'string' || !COLLECTIONS.ATTENDANCE) {
        throw new Error('Attendance collection is not configured');
    }
    if (!tenantId) throw new Error('Missing tenantId');
    if (!scope) throw new Error('Missing scope');
    if (!monthKey) throw new Error('Missing monthKey');
    if (!dateKey) throw new Error('Missing dateKey');
    if (!personId) throw new Error('Missing personId');
    if (!/^\d{4}-\d{2}$/.test(monthKey)) throw new Error(`Invalid monthKey: ${monthKey}`);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateKey)) throw new Error(`Invalid dateKey: ${dateKey}`);
    if (scope !== 'teachers' && scope !== 'staff' && scope !== 'students') throw new Error(`Invalid scope: ${scope}`);

    const entryId = `${dateKey}_${personId}`;
    const ref = doc(db(), COLLECTIONS.ATTENDANCE, tenantId, scope, monthKey, 'entries', entryId);

    if (!status) {
        await deleteDoc(ref);
        return { entryId, deleted: true };
    }

    await setDoc(
        ref,
        {
            entryId,
            dateKey,
            personId,
            status, // 'P' | 'A' | 'LV' | 'EV'
            // optional metadata (stored for future detailed history views)
            checkInTime: checkInTime || null, // 'hh:mm A'
            reason: reason || null,
            updatedAt: serverTimestamp(),
            createdAt: serverTimestamp(),
        },
        { merge: true }
    );

    return { entryId, deleted: false };
}

